import * as types from './action-types';

const getNotificationCount = () => {
    return dispatch => new Promise((resolve, reject) => {
        dispatch({ type: types.SET_FETCH_NOTIFICATION_TYPE, payload: {} });
    });
};

const delNotificationType = () => {
    return dispatch => new Promise((resolve, reject) => {
        dispatch({ type: types.DEL_FETCH_NOTIFICATION_TYPE, payload: {} });
    });
};

const getAccidentNotification = () => {
    return dispatch => new Promise((resolve, reject) => {
        dispatch({ type: types.SET_FETCH_ACCIDENT_NOTIFICATION_TYPE, payload: {} });
    });
};

const delAccidentNotification = () => {
    return dispatch => new Promise((resolve, reject) => {
        dispatch({ type: types.DEL_FETCH_ACCIDENT_NOTIFICATION_TYPE, payload: {} });
    });
};

export default {
    getNotificationCount,
    delNotificationType,
    getAccidentNotification,
    delAccidentNotification
};



// WEBPACK FOOTER //
// ./src/store/modules/notification/actions.js